import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [!_vm.isAllowed ? [_c("div", {
    staticClass: "content-centered small text-left"
  }, [_c("div", {
    staticClass: "text-center mb-3"
  }, [_vm._v("It seems you can't access to this information")]), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("Close")])], 1)])] : [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("New container order")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.addingOrder.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingOrder.form, "valid", $$v);
      },
      expression: "addingOrder.form.valid"
    }
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingCustomers.isPending || _vm.isAnyActionInProgress || _vm.addingOrder.form.departureWarehouseId > 0,
      items: _vm.gettingCustomers.result,
      "item-value": "id_user",
      "item-text": "full_name",
      label: !_vm.gettingCustomers.isPending ? "Importer/Dispatch customer" : "Loading...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue]
    },
    model: {
      value: _vm.addingOrder.form.customerId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingOrder.form, "customerId", $$v);
      },
      expression: "addingOrder.form.customerId"
    }
  })], 1), _vm.addingOrder.form.customerId > 0 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingWarehouses.isPending || _vm.isAnyActionInProgress || _vm.addingOrder.form.arrivalWarehouseId > 0,
      items: _vm.gettingWarehouses.result,
      clearable: "",
      "item-value": "id_warehouse",
      "item-text": "name",
      label: !_vm.gettingWarehouses.isPending ? "Departure warehouse" : "Loading...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue]
    },
    on: {
      change: _vm.changeDepartureWarehouseId
    },
    model: {
      value: _vm.addingOrder.form.departureWarehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingOrder.form, "departureWarehouseId", $$v);
      },
      expression: "addingOrder.form.departureWarehouseId"
    }
  })], 1) : _vm._e(), _vm.addingOrder.form.departureWarehouseId > 0 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingWarehouses.isPending || _vm.isAnyActionInProgress || _vm.addingOrder.form.subOrderIds.length > 0,
      items: _vm.availableArrivalWarehouses,
      clearable: "",
      "item-value": "id_warehouse",
      "item-text": "name",
      label: !_vm.gettingWarehouses.isPending ? "Arrival warehouse of additionals products" : "Loading...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue]
    },
    on: {
      change: _vm.changeDepartureArrivalId
    },
    model: {
      value: _vm.addingOrder.form.arrivalWarehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingOrder.form, "arrivalWarehouseId", $$v);
      },
      expression: "addingOrder.form.arrivalWarehouseId"
    }
  })], 1) : _vm._e(), _vm.addingOrder.form.arrivalWarehouseId > 0 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      multiple: "",
      chips: "",
      "deletable-chips": "",
      clearable: "",
      disabled: _vm.gettingCompatibleOrders.isPending || _vm.isAnyActionInProgress,
      items: _vm.gettingCompatibleOrders.result,
      "item-value": "id_order",
      "item-text": "displayLabel",
      label: !_vm.gettingCompatibleOrders.isPending ? "Orders compatible" : "Loading...",
      "no-data-text": _vm.gettingCompatibleOrders.result.length === 0 ? "No compatible existing orders, on the same departure warehouse" : "All compatible orders has been selected",
      "hide-details": "auto",
      "hide-selected": "",
      filter: _vm.filterVAutocomplete,
      "search-input": _vm.addingOrder.subordersInputSearch
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        return _vm.$set(_vm.addingOrder, "subordersInputSearch", $event);
      },
      "update:search-input": function updateSearchInput($event) {
        return _vm.$set(_vm.addingOrder, "subordersInputSearch", $event);
      },
      change: function change($event) {
        _vm.addingOrder.subordersInputSearch = "";
      }
    },
    model: {
      value: _vm.addingOrder.form.subOrderIds,
      callback: function callback($$v) {
        _vm.$set(_vm.addingOrder.form, "subOrderIds", $$v);
      },
      expression: "addingOrder.form.subOrderIds"
    }
  }), _c(VAlert, {
    staticClass: "--small mt-2",
    attrs: {
      dense: "",
      outlined: "",
      type: "info",
      color: "blue",
      text: ""
    }
  }, [_vm._v(" Orders with : same warehouse departure, same country of arrival, sea freight, not invoiced, not shipped, not deliver as available stocks, professional customer ")])], 1) : _vm._e()]), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      loading: _vm.addingOrder.isPending,
      disabled: _vm.isAnyActionInProgress || !_vm.addingOrder.form.valid
    },
    on: {
      click: function click($event) {
        return _vm.addOrder();
      }
    }
  }, [_vm._v(" Create container order ")])], 1)], 1)], 1)]], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };